// mui
import { ImageList, ImageListItem, Skeleton } from '@mui/material';

// local
import { PostShowMediaProfile } from './post-showmedia.jsx';
import { PostShowMediaOverlay } from './post-showmediaoverlay.jsx';

function ProfileImages({ posts, loading, onClick }) {
    const getColRow = (index) => {
        const mod = index % 10;
        return mod === 0 || mod === 7 ? 2 : 1;
    };

    const listSx = { my: '1px', width: '100%', overflow: 'hidden' };
    const itemSx = (hasPost) => ({
        border: hasPost ? 0 : 1,
        borderColor: 'primary.main',
        overflow: 'hidden',
        cursor: hasPost ? 'pointer' : 'default',
        position: 'relative',
    });

    if (loading) {
        return (
            <ImageList variant='quilted' cols={4} gap={2} sx={listSx}>
                {Array.from({ length: 10 }, (_, i) => (
                    <ImageListItem
                        key={i}
                        cols={getColRow(i)}
                        rows={getColRow(i)}
                        sx={{ border: 1, borderColor: 'primary.main', overflow: 'hidden' }}>
                        <Skeleton
                            variant='rectangular'
                            height={getColRow(i) === 2 ? getColRow(i) * 100 : getColRow(i) * 90}
                            sx={{ m: 1 }}
                        />
                    </ImageListItem>
                ))}
            </ImageList>
        );
    }

    return (
        <ImageList variant='quilted' cols={4} gap={2} sx={listSx}>
            {posts?.map((post, index) => (
                <ImageListItem
                    key={post?._id ?? index}
                    cols={getColRow(index)}
                    rows={getColRow(index)}
                    onClick={post ? (e) => onClick?.(e, index, post) : undefined}
                    sx={itemSx(!!post)}>
                    {PostShowMediaProfile(post)}
                    {post && PostShowMediaOverlay(post)}
                </ImageListItem>
            ))}
        </ImageList>
    );
}

export { ProfileImages };
